<template>
    <div class="zone-header">
        <div class="title font-lg">{{ info.title }}</div>

        <div class="d-flex align-items-center mt-1">
            <div class="text-muted mr-5">{{ info.created_at }}</div>
            <div class="text-muted mr-5">
                <a-icon type="eye" /> {{ info.view_num || 0}}
            </div>
            <div class="text-muted">
                <a-icon type="heart" /> {{ info.collect_num || 0 }}
            </div>

            <div class="flex-fill"></div>

            <o-like v-if="info.id" :id="info.id" :info="info" />        

            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: ['info']
}
</script>

<style lang="scss" scoped>
.zone-header {
    &::v-deep .anticon {
        vertical-align: -0.15em;
    }
}
</style>